import axios from 'axios';
import AplicaionesApi from './aplicaciones';
import { safeLocalStorage, useLocalStorage } from 'frontend/helpers/ssr-helper';

export default {
  async obtenerOpcionesPagoMundigea() {
    const appToken = await AplicaionesApi.obtenerAplicacion('www.mundigea.com.ar');
    const config = {
      headers: {
        'Content-type': 'application/json',
        Authorization: `Bearer ${appToken.access_token}`,
      },
    };
    return axios
      .get(`${process.env.REACT_APP_PAYMENT_PROMOTIONS}/promotions/packages/on-date/application`, config)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        console.error(error);
      });
  },
  obtenerPromocionesDePago: () => {
    const config = {
      headers: {
        'Content-type': 'application/json',
        Authorization: `Bearer ${safeLocalStorage.getItem('token')}`,
      },
    };
    return axios
      .get(`${process.env.REACT_APP_PAYMENT_PROMOTIONS}/promotions/packages/on-date/application`, config)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        console.error(error);
      });
  },
};
